export interface AdjustmentCouponGet {
    item: string
    category: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentCouponGetProps {
    item: string
    category: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentCouponGet = (obj: ObjectToAdjustmentCouponGetProps): AdjustmentCouponGet => {
    return {
        item: obj.item,
        category: obj.category,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}